import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../framework/redux/hooks";
import { getTransportOrderNotifications } from "../../services/transportOrderNotificationService";
import { setNotifications } from "../../framework/redux/slices/notificationSlice";
import { NotificationSource } from "../../models/transport/transportOrderNotification";

// Thirty seconds
const pollingInterval = 1000 * 30;

export const useNotificationPolling = (employeeId: string, interval: number = pollingInterval) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    // Extract only the pathname to avoid unnecessary re-renders
    const { pathname } = location;

    useEffect(() => {
        const pollNotifications = async() => {
            try {
                const response = await getTransportOrderNotifications({
                    employeeId: employeeId,
                    source: NotificationSource.Desktop
                });
                if (response.data.length > 0) {
                    dispatch(setNotifications(response.data));

                    // Redirect only if the user is not on the order details page
                    if (!pathname.startsWith("/transport/order")) {
                        navigate("/notifications");
                    }
                } else {
                    dispatch(setNotifications([]));
                }
            } catch (error) {
                console.error("Error polling notifications:", error);
            }
        };

        const intervalId = setInterval(() => {
            void pollNotifications();
        }, interval);
        void pollNotifications();

        return () => clearInterval(intervalId);
    }, [employeeId, interval, navigate, pathname, dispatch]);
};
